// French translations
const fr = {
  // Common
  common: {
    loading: "Chargement...",
    error: "Erreur",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    share: "Partager",
    search: "Rechercher",
    seeMore: "Voir plus",
    seeLess: "Voir moins",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    yes: "Oui",
    no: "Non",
    ok: "OK",
    close: "Fermer",
    send: "Envoyer",
    submit: "Soumettre",
    refresh: "Actualiser",
    retry: "Réessayer",
    offline: "Hors ligne",
    online: "En ligne",
  },

  // Navigation
  nav: {
    home: "Accueil",
    feed: "Fil",
    map: "Carte",
    chat: "Chat",
    profile: "Profil",
    messages: "Messages",
    notifications: "Notifications",
    settings: "Paramètres",
    search: "Recherche",
    calendar: "Calendrier",
    create: "Créer",
  },

  // Landing Page
  landing: {
    tagline: "Lo réseau social péi",
    headline: "Tout ce qui se passe",
    headlineHighlight: "dans votre quartier",
    description: "Alertes, événements, bons plans... Restez connecté à votre commune. Partagez et découvrez ce qui se passe autour de vous.",
    joinButton: "Rejoindre Bourbon",
    discoverButton: "Découvrir",
    whyBourbon: "Pourquoi Bourbon ?",
    features: {
      alerts: {
        title: "Alertes en temps réel",
        description: "Coupures d'eau, embouteillages, incidents... Soyez informé instantanément."
      },
      events: {
        title: "Événements locaux",
        description: "Concerts, marchés, fêtes de quartier... Ne ratez plus rien."
      },
      deals: {
        title: "Bons plans",
        description: "Promos, ouvertures, offres spéciales des commerces de votre quartier."
      },
      community: {
        title: "Communauté",
        description: "Échangez avec vos voisins, entraidez-vous, créez du lien."
      }
    },
    stats: {
      communes: "24 communes",
      communesDesc: "Toute La Réunion couverte",
      realtime: "Temps réel",
      realtimeDesc: "Alertes instantanées",
      free: "100% gratuit",
      freeDesc: "Sans publicité intrusive"
    },
    cta: "Prêt à rejoindre votre communauté ?",
    ctaButton: "Créer mon compte gratuitement"
  },

  // Auth
  auth: {
    login: "Connexion",
    register: "Inscription",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    name: "Nom",
    commune: "Commune",
    selectCommune: "Sélectionnez votre commune",
    forgotPassword: "Mot de passe oublié ?",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Déjà un compte ?",
    orContinueWith: "Ou continuer avec",
    googleLogin: "Continuer avec Google",
    loginSuccess: "Connexion réussie !",
    registerSuccess: "Inscription réussie !",
    loginError: "Email ou mot de passe incorrect",
    registerError: "Erreur lors de l'inscription",
    welcome: "Bienvenue sur Bourbon",
    welcomeBack: "Bon retour !",
  },

  // Feed
  feed: {
    title: "Fil d'actualités",
    empty: "Aucune publication pour le moment",
    emptyFiltered: "Aucune publication ne correspond à vos filtres",
    newPost: "Nouvelle publication",
    following: "Abonnements",
    allPosts: "Tous les posts",
    trending: "Tendances",
    filters: {
      all: "Tout",
      alerts: "Alertes",
      events: "Événements",
      deals: "Bons Plans",
      info: "Infos"
    },
    sortBy: {
      recent: "Plus récents",
      popular: "Plus populaires",
      trending: "Tendances"
    }
  },

  // Posts
  post: {
    create: "Créer un post",
    title: "Titre",
    titlePlaceholder: "Un titre accrocheur...",
    content: "Contenu",
    contentPlaceholder: "Partagez ce qui se passe...",
    category: "Catégorie",
    selectCategory: "Choisir une catégorie",
    commune: "Commune",
    quartier: "Quartier",
    selectQuartier: "Choisir un quartier (optionnel)",
    addImage: "Ajouter une image",
    addAudio: "Ajouter un audio",
    addPoll: "Ajouter un sondage",
    pollQuestion: "Question du sondage",
    pollOption: "Option",
    addOption: "Ajouter une option",
    pollEndDate: "Date de fin du sondage",
    eventDate: "Date de l'événement",
    publish: "Publier",
    publishing: "Publication...",
    published: "Publié !",
    deleteConfirm: "Supprimer ce post ?",
    deleted: "Post supprimé",
    like: "J'aime",
    liked: "Aimé",
    comment: "Commenter",
    comments: "Commentaires",
    noComments: "Aucun commentaire",
    addComment: "Ajouter un commentaire...",
    share: "Partager",
    shares: "partages",
    report: "Signaler",
    reported: "Signalé",
    vote: "Voter",
    voted: "Voté",
    votes: "votes",
    pollEnded: "Sondage terminé",
    pollEndsIn: "Se termine dans",
  },

  // Categories
  categories: {
    alerte: "Alerte",
    evenement: "Événement",
    bon_plan: "Bon Plan",
    info: "Info"
  },

  // Profile
  profile: {
    myProfile: "Mon profil",
    editProfile: "Modifier le profil",
    bio: "Bio",
    bioPlaceholder: "Parlez-nous de vous...",
    followers: "Abonnés",
    following: "Abonnements",
    posts: "Publications",
    follow: "Suivre",
    unfollow: "Ne plus suivre",
    message: "Message",
    badges: "Badges",
    noBadges: "Pas encore de badges",
    joined: "Membre depuis",
    commerce: "Profil Commerce",
    verifiedCommerce: "Commerce vérifié",
  },

  // Messages
  messages: {
    title: "Messages",
    noConversations: "Aucune conversation",
    startConversation: "Démarrer une conversation",
    typeMessage: "Écrivez votre message...",
    sent: "Envoyé",
    delivered: "Délivré",
    read: "Lu",
    newMessage: "Nouveau message",
    unread: "non lu",
    unreadPlural: "non lus",
  },

  // Notifications
  notifications: {
    title: "Notifications",
    empty: "Aucune notification",
    markAllRead: "Tout marquer comme lu",
    newLike: "a aimé votre publication",
    newComment: "a commenté votre publication",
    newFollow: "vous suit maintenant",
    newMessage: "vous a envoyé un message",
    types: {
      like: "J'aime",
      comment: "Commentaire",
      follow: "Abonnement",
      message: "Message"
    }
  },

  // Chat
  chat: {
    title: "Chat de quartier",
    selectRoom: "Sélectionnez un salon",
    noMessages: "Aucun message dans ce salon",
    typeMessage: "Écrivez votre message...",
    members: "membres",
    join: "Rejoindre",
    joined: "Rejoint",
    rooms: "Salons",
  },

  // Map
  map: {
    title: "Carte",
    nearYou: "Près de chez vous",
    showAll: "Afficher tout",
    filters: "Filtres",
  },

  // Calendar
  calendar: {
    title: "Calendrier",
    noEvents: "Aucun événement prévu",
    today: "Aujourd'hui",
    upcoming: "À venir",
  },

  // Search
  search: {
    title: "Recherche",
    placeholder: "Rechercher des posts, utilisateurs...",
    noResults: "Aucun résultat",
    trending: "Tendances du moment",
    users: "Utilisateurs",
    posts: "Publications",
  },

  // Settings
  settings: {
    title: "Paramètres",
    account: "Compte",
    notifications: "Notifications",
    privacy: "Confidentialité",
    language: "Langue",
    theme: "Thème",
    themes: {
      light: "Clair",
      dark: "Sombre",
      system: "Système"
    },
    about: "À propos",
    help: "Aide",
    logout: "Déconnexion",
    deleteAccount: "Supprimer le compte",
    version: "Version",
    pushNotifications: "Notifications push",
    emailNotifications: "Notifications email",
  },

  // Commerce
  commerce: {
    title: "Profil Commerce",
    name: "Nom du commerce",
    description: "Description",
    category: "Catégorie",
    address: "Adresse",
    phone: "Téléphone",
    website: "Site web",
    hours: "Horaires",
    categories: {
      restaurant: "Restaurant",
      boutique: "Boutique",
      service: "Service",
      artisan: "Artisan",
      other: "Autre"
    },
    verify: "Demander la vérification",
    verificationPending: "Vérification en cours",
    verified: "Vérifié",
  },

  // Report
  report: {
    title: "Signaler",
    reason: "Raison du signalement",
    reasons: {
      spam: "Spam",
      inappropriate: "Contenu inapproprié",
      harassment: "Harcèlement",
      misinformation: "Fausse information",
      other: "Autre"
    },
    details: "Détails supplémentaires",
    detailsPlaceholder: "Expliquez pourquoi vous signalez ce contenu...",
    submit: "Envoyer le signalement",
    submitted: "Signalement envoyé",
    thanks: "Merci de votre vigilance !",
  },

  // Time
  time: {
    now: "À l'instant",
    minutesAgo: "il y a {n} min",
    hoursAgo: "il y a {n}h",
    daysAgo: "il y a {n}j",
    weeksAgo: "il y a {n} sem",
    monthsAgo: "il y a {n} mois",
    yearsAgo: "il y a {n} an(s)",
  },

  // Errors
  errors: {
    generic: "Une erreur est survenue",
    network: "Erreur de connexion",
    notFound: "Page non trouvée",
    unauthorized: "Accès non autorisé",
    forbidden: "Accès interdit",
    serverError: "Erreur serveur",
    tryAgain: "Veuillez réessayer",
  },

  // PWA
  pwa: {
    offline: "Vous êtes hors ligne",
    offlineMessage: "Vérifiez votre connexion internet",
    updateAvailable: "Mise à jour disponible",
    updateMessage: "Une nouvelle version est disponible. Voulez-vous rafraîchir ?",
    install: "Installer l'application",
  }
};

export default fr;
